import type { ComposeSnapshotIndexEntry } from './types';
import type { ComposeSnapshot } from '../../models/composeSnapshot';
import {
  COMPOSE_SNAPSHOT_EXCERPT_MAX_CHARS,
  COMPOSE_SNAPSHOT_INDEX_MAX_RECIPIENTS,
} from '../../utils/constants/drafts';
import { stripHtml } from '../../utils/stripHtml';

type DisplayFields = Pick<
  ComposeSnapshotIndexEntry,
  'subject' | 'recipients' | 'excerpt'
>;

export const toDisplayFields = (snapshot: ComposeSnapshot): DisplayFields => ({
  subject: snapshot.subject,
  recipients: snapshot.toAddresses
    .map((address) => address.label || address.value)
    .filter(Boolean)
    .slice(0, COMPOSE_SNAPSHOT_INDEX_MAX_RECIPIENTS),
  excerpt: stripHtml(snapshot.message).slice(
    0,
    COMPOSE_SNAPSHOT_EXCERPT_MAX_CHARS,
  ),
});

export const formatSnapshotRecipients = (
  recipients: readonly string[],
  emptyText: string,
): string => recipients.join(', ') || emptyText;
